// Kiosk Mode
export const IS_KIOSK_MODE = "IS_KIOSK_MODE";

//ISwichable actions (powerSwitches, lights, dimmers, ...)
export const SWITCH_ON = "SWITCH_ON";
export const SWITCH_OFF = "SWITCH_OFF";
export const TURN_ON = "TURN_ON";
export const TURN_OFF = "TURN_OFF";

export const TOGGLE_SWITCH = "TOGGLE_SWITCH";
export const TURN_ON_LIGHTS = "TURN_ON_LIGHTS";
export const TURN_OFF_LIGHTS = "TURN_OFF_LIGHTS";
export const TURN_ON_OUTLETS = "TURN_ON_OUTLETS";
export const TURN_OFF_OUTLETS = "TURN_OFF_OUTLETS";
export const TURN_ON_SIRENS = "TURN_ON_SIRENS";
export const TURN_OFF_SIRENS = "TURN_OFF_SIRENS";
export const TURN_ON_POWER_SWITCHES = "TURN_ON_POWER_SWITCHES";
export const TURN_OFF_POWER_SWITCHES = "TURN_OFF_POWER_SWITCHES";
export const TURN_ON_WATERING_SWITCHES = "TURN_ON_WATERING_SWITCHES";
export const TURN_OFF_WATERING_SWITCHES = "TURN_OFF_WATERING_SWITCHES";
export const TURN_ON_AIR_CONDITIONERS = "TURN_ON_AIR_CONDITIONERS";
export const TURN_OFF_AIR_CONDITIONERS = "TURN_OFF_AIR_CONDITIONERS";
export const OPEN_ALL_ACCESS_CONTROL_DOORS = "OPEN_ALL_ACCESS_CONTROL_DOORS";
export const CALL = "CALL";
export const STATE = "STATE";
export const FLOOR_STATE = "FLOOR_STATE";
export const ASK_TO_OPEN = "ASK_TO_OPEN";
export const VIP = "VIP";

//IDimmer actions (dimmerLights, curtains & roller blinds, air conditioners, ...)
export const DIMMER_CHANGE_VALUE = "DIMMER_SWITCH_ON_AT";
export const DIMMER_INCREASE = "DIMMER_INCREASE";
export const DIMMER_DECREASE = "DIMMER_DECREASE";
export const GET_DIMMER_VALUE = "GET_DIMMER_VALUE"; // get current value of dimmer device (percent, temp, ...)

//IOpenClosable actions (doors, garage doors, ...))
export const OPEN = "OPEN";
export const CLOSE = "CLOSE";

export const CURTAIN_OPEN = "CURTAIN_OPEN";
export const CURTAIN_CLOSE = "CURTAIN_CLOSE";

//get current status of device. for example ['isOpen', 'isOpening' , 'isClosing' , 'isClose'] for IOpenClosable devices
export const GET_STATUS = "GET_STATUS";

// actions for common entities.
export const ADD = "ADD";
export const ADD_GPIO = "ADD_GPIO";
export const ADD_ACCESS_CONTROL = "ADD_ACCESS_CONTROL";
export const UPDATE_ACCESS_CONTROL = "UPDATE_ACCESS_CONTROL";
export const ADD_TOUCH_PANEL = "ADD_TOUCH_PANEL";
export const UPDATE_TOUCH_PANEL = "UPDATE_TOUCH_PANEL";
export const CLEAR_NEW_TOUCH_PANEL = "CLEAR_NEW_TOUCH_PANEL";
export const ADD_SMART_SPEAKER = "ADD_SMART_SPEAKER";
export const ADD_SILENT = "ADD_SILENT";
export const ADD_DOOR_SENSOR = "ADD_DOOR_SENSOR";
export const DEVICEDETECTOR_UPDATE_VALUE = "DEVICEDETECTOR_UPDATE_VALUE";
export const ADD_MULTIPLE = "ADD_MULTIPLE";
export const REMOVE = "REMOVE";
export const DELETE = "DELETE";
export const UPDATE = "UPDATE";
export const UPDATE_GPIO = "UPDATE_GPIO";
export const UPDATE_SMART_SPEAKER = "UPDATE_SMART_SPEAKER";
export const DETAILS = "DETAILS";
export const ALL_IN_AREA = "ALL_IN_AREA";
export const ALL = "ALL"; // get a list of all items. (for initiating local data store, ...)
export const ALL_CACHE = "ALL_CACHE"; // get a list from cache and set to reducer. (for quick access, ...)
export const ALL_PARTIAL = "ALL_PARTIAL"; // get a section list of all items. (for receiving big arrays in many partial parts, ...)
export const ALL_SUMMARIES = "ALL_SUMMARIES";
export const GET_ALL = "GET_ALL"; // get a list of all items. (for initiating local data store, ...)
export const CLEAR = "CLEAR";
export const CLEAR_CACHE = "CLEAR_CACHE";
export const TYPE_ALL = "TYPE_ALL";
export const REFRESH = "REFRESH";
export const TYPE_EVENTS = "TYPE_EVENTS"; // get a key-value pair (<string , array>) contains deviceGroupNames and related Events
export const TEST = "TEST"; // for testing reducers functionalities.
export const HEAL = "HEAL";
export const PRESSED = "PRESSED";
export const GET_MODULES = "GET_MODULES";
export const SHOW_SPLASHSCREEN = "SHOW_SPLASHSCREEN";
export const SET_MODULES = "SET_MODULES";
export const SUBMIT_LOG = "SUBMIT_LOG";
export const NOT_CONNECTED = "NOT_CONNECTED";
export const SET_CAMERA_ID = "SET_CAMERA_ID";
export const ASK_PIN = "ASK_PIN";
export const ASK_PIN_CLEAR = "ASK_PIN_CLEAR";

export const ADD_STATE = "ADD_STATE";
export const UPDATE_STATE = "UPDATE_STATE";
export const REMOVE_STATE = "REMOVE_STATE";
export const ACTIVE_STATE = "ACTIVE_STATE";
export const DE_ACTIVE_STATE = "DE_ACTIVE_STATE";
export const ON_OCCUPATION_CHANGE = "ON_OCCUPATION_CHANGE";
export const UNLOCK = "UNLOCK";
export const LOCK = "LOCK";
export const OPEN_DOOR = "OPEN_DOOR";

export const UPDATE_VALUE = "UPDATE_VALUE";
export const UPDATE_BATTERY = "UPDATE_BATTERY";
export const UPDATE_THERMOSTAT_FAN_MODE = "UPDATE_THERMOSTAT_FAN_MODE";
export const UPDATE_THERMOSTAT_FAN_STATE = "UPDATE_THERMOSTAT_FAN_STATE";
export const UPDATE_THERMOSTAT_MODE = "UPDATE_THERMOSTAT_MODE";
export const UPDATE_THERMOSTAT_OPERATING_STATE =
  "UPDATE_THERMOSTAT_OPERATING_STATE";
export const UPDATE_SET_POINT = "UPDATE_SET_POINT";

export const RUN_RESULT = "RUN_RESULT";
export const CLEAR_RUN_RESULT = "CLEAR_RUN_RESULT";
// actions for App reducer
export const UPDATE_ACCESS_TOKEN = "UPDATE_ACCESS_TOKEN";
export const UPDATE_USER_FULL_NAME = "UPDATE_USER_FULL_NAME";
export const UPDATE_SERVER_URL = "UPDATE_SERVER_URL";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_SESSION = "UPDATE_SESSION";
export const RECONNECT = "RECONNECT";
export const GET_BUILDING_LIST = "GET_BUILDING_LIST";
export const GET_SERVER_LIST = "GET_SERVER_LIST";
export const GET_CURRENT_SERVER = "GET_CURRENT_SERVER";
export const GET_CURRENT_BUILDING = "GET_CURRENT_BUILDING";
export const SET_BUILDINGS = "SET_BUILDINGS";
export const SET_SERVERS = "SET_SERVERS";
export const ADD_SERVER = "ADD_SERVER";
export const ADD_BUILDING = "ADD_BUILDING";
export const ADD_BUILDINGS = "ADD_BUILDINGS";
export const UPDATE_SERVERS = "UPDATE_SERVERS";
export const REMOVE_BUILDING = "REMOVE_BUILDING";
export const UPDATE_CURRENT_BUILDING = "UPDATE_CURRENT_BUILDING";
export const UPDATE_CURRENT_SERVER = "UPDATE_CURRENT_SERVER";

export const INCLUDE_NODE = "INCLUDE_NODE";
export const INCLUDE_NODE_GET_TIMEOUT = "INCLUDE_NODE_GET_TIMEOUT";
export const COUNT_DOWN_TIMEOUT = "COUNT_DOWN_TIMEOUT";
//export const RESET_TIMEOUT = "RESET_TIMEOUT";
export const INCLUDE_NODE_TIMEOUT_REACHED = "INCLUDE_NODE_TIMEOUT_REACHED";
export const TYPE_ACTIONS = "TYPE_ACTIONS";
export const SERVER = "SERVER";
export const UNLINK_DEVICE = "UNLINK_DEVICE";
export const COPY_DEVICES_TO_AREAS = "COPY_DEVICES_TO_AREAS";
export const MOVE_DEVICES_TO_AREAS = "MOVE_DEVICES_TO_AREAS";
export const GET_DEVICE_QUICK_ACCESS = "GET_DEVICE_QUICK_ACCESS";
export const SET_DEVICE_QUICK_ACCESS = "SET_DEVICE_QUICK_ACCESS";
export const TRANSPORT_RESULT = "TRANSPORT_RESULT";
export const RESET_TRANSPORT_RESULT = "RESET_TRANSPORT_RESULT";
export const RESET_NEW_INCLUDED_ID = "RESET_NEW_INCLUDED_ID";

export const REGISTER_COMPLETED = "REGISTER_COMPLETED";
export const CLEAR_NEW_USER_CACHE = "CLEAR_NEW_USER_CACHE";
export const FORCE_MEMBER_INIT = "FORCE_MEMBER_INIT";
export const GET_ACCESS_LIST = "GET_ACCESS_LIST";
export const SET_ACCESS_LIST = "SET_ACCESS_LIST";
export const UPDATE_EXPIRE = "UPDATE_EXPIRE";
export const MODIFIED = "MODIFIED";
export const LOGOUT = "LOGOUT";
export const RESET_LOGOUT = "RESET_LOGOUT";
export const ARMED_CHANGE = "ARMED_CHANGE";
export const ARM = "ARM";
export const DISARM = "DISARM";
export const ARM_REPORT = "ARM_REPORT";
export const BREACHED = "BREACHED";
export const ARM_REPORT_RESET = "ARM_REPORT_RESET";
export const RESET_ASK_TO_OPEN = "RESET_ASK_TO_OPEN";
export const LOG = "LOG";
export const LOAD = "LOAD";
export const GET_SESSIONS = "GET_SESSIONS";
export const CLOSE_SESSIONS = "CLOSE_SESSIONS";

export const TOGGLE_ENABLE = "TOGGLE_ENABLE";
export const RUN = "RUN";

export const CONNECTED = "CONNECTED";
export const DISCONNECTED = "DISCONNECTED";
export const FORCE_INIT = "FORCE_INIT";
export const UPDATE_APP_REDUCER = "UPDATE_APP_REDUCER";

//notification types
export const WILL_TIMEOUT = "WILL_TIMEOUT";
export const DID_TIMEOUT = "DID_TIMEOUT";
export const SCENARIO_REPORTS = "SCENARIO_REPORTS";
export const MESSAGE_TOAST = "MESSAGE_TOAST";
export const CLEAR_MESSAGE_TOAST = "CLEAR_MESSAGE_TOAST";

export const ADD_TRACK = "ADD_TRACK";
export const REMOVE_TRACK = "REMOVE_TRACK";
export const RE_ORDER_TRACKS = "RE_ORDER_TRACKS";

export function normalizePercent(percent) {
  let _percent = Number(percent) || 0;
  if (_percent < 0) _percent = 0;
  if (_percent > 100) _percent = 100;
  return _percent;
}

// API Actions
export const MY_ORDERS = "MY_ORDERS";
export const MY_FACILITY_LIST = "MY_FACILITY_LIST";
export const MY_CARWASH_ORDERS = "MY_CARWASH_ORDERS";
export const MY_COFFEESHOP_AND_RESTAURANT_ORDERS =
  "MY_COFFEESHOP_AND_RESTAURANT_ORDERS";
export const MY_TRANSACTIONS = "MY_TRANSACTIONS";
export const MY_PARKING_ORDERS = "MY_PARKING_ORDERS";
export const CONFIRM_ORDER = "CONFIRM_ORDER";
export const CONFIRM_CARWASH = "CONFIRM_CARWASH";
export const CONFIRM_RESTAURANT = "CONFIRM_RESTAURANT";
export const CONFIRM_COFFEESHOP = "CONFIRM_COFFEESHOP";

// user messages
export const NEW_MESSAGES_COUNT = "NEW_MESSAGES_COUNT";
export const MARK_AS_SEEN = "MARK_AS_SEEN";
export const MARK_ALL_AS_SEEN = "MARK_ALL_AS_SEEN";

// smart speaker
export const PLAY = "PLAY";
export const PAUSE = "PAUSE";
export const RESUME = "RESUME";
export const STOP = "STOP";
export const NEXT = "NEXT";
export const PREVIOUS = "PREVIOUS";
export const SEEK = "SEEK";
export const CHANGE_VOLUME = "CHANGE_VOLUME";
export const TOGGLE_MUTE = "TOGGLE_MUTE";
export const UPDATE_SLAVE = "UPDATE_SLAVE";
export const CHANGE_INPUT_SOURCE = "CHANGE_INPUT_SOURCE";

// === Device Controller ===
export const UPDATE_CONTROLLER = "UPDATE_CONTROLLER";

// === Buildings ===
export const USER_JOINED = "USER_JOINED";

// === Widget ===
export const ANNOUNCEMENT = "ANNOUNCEMENT";
export const CLEAR_ANNOUNCEMENT = "CLEAR_ANNOUNCEMENT";

// === Access Control & TCP Sensor ===
export const DOOR_STATE_CHANGED = "DOOR_STATE_CHANGED";
export const DEVICE_CONNECTION_CHANGED = "DEVICE_CONNECTION_CHANGED";
export const DEVICE_TAMPER_CHANGED = "DEVICE_TAMPER_CHANGED";
export const PLAY_SOUND_ALARM = "PLAY_SOUND_ALARM";
export const STOP_SOUND_ALARM = "STOP_SOUND_ALARM";
export const REQUEST_NOTIFICATION = "REQUEST_NOTIFICATION";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_CAMERA = "CLOSE_CAMERA";
export const ACK_ANNOUNCEMENT = "ACK_ANNOUNCEMENT";
export const ACK_ALL = "ACK_ALL";
export const ACK_CONFIRM = "ACK_CONFIRM";
export const ACK_CONFIRMED = "ACK_CONFIRMED";
export const TOGGLE_SYSTEM_LOCK = "TOGGLE_SYSTEM_LOCK";
export const SYSTEM_LOCK_CHANGED = "SYSTEM_LOCK_CHANGED";
